import { Component, NgModule, AfterViewInit, OnInit } from '@angular/core';
import { SystemDropdownAvatarModule } from '../dropdown-avatar/dropdown-avatar.component';
import { AuthService, UserService } from '@app/core/services';
import { Router } from '@angular/router';
import { initDropdowns } from 'flowbite';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SystemIconComponentModule } from '../../atoms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-system-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements AfterViewInit, OnInit {
  items = [
    {
      title: 'YOUR PROFILE',
      action: () => {
        this._router.navigate(['/panel/user-profile']);
      },
    },
    {
      title: 'SIGN OUT',
      action: () => {
        this._authService.logout();
      },
    },
  ];

  user$: Observable<string> | undefined;
  imageAvatar$: Observable<string> | undefined;

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _userService: UserService
  ) {}

  ngOnInit(): void {
    this.user$ = this._userService.userFullName;
    this.imageAvatar$ = this._userService.userAvatar;
  }

  ngAfterViewInit(): void {
    initDropdowns();
  }

  goDocumentsList(): void {
    this._router.navigate(['/panel/automations']);
  }
}

@NgModule({
  declarations: [NavbarComponent],
  exports: [NavbarComponent],
  imports: [CommonModule, SystemDropdownAvatarModule, SystemIconComponentModule, TranslateModule],
})
export class SystemNavbarModule {}
